import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  TemplateRef
} from '@angular/core';

@Component({
  selector: 'ppl-info-box',
  templateUrl: './info-box.component.html',
  styleUrls: ['./info-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PplInfoBoxComponent {
  @Input() type: PplInfoBoxType = 'info';
  @Input() text: string | null;
  @Input() icon: string | null;
  @Input() buttonText: string | null;
  @Input() buttonDisabled = false;
  @Input() enableActions = true;
  @Input() enableClose = false;
  @Input() drawerOpen = false;
  @Input() @HostBinding('style.borderRadius.px') borderRadius = 8;

  @Output() close = new EventEmitter();
  @Output() buttonClick = new EventEmitter();

  @ContentChild('textTemplate', { static: false }) textTemplate: TemplateRef<any>;
  @ContentChild('drawerTemplate', { static: false }) drawerTemplate: TemplateRef<any>;
  @ContentChild('actionsTemplate', { static: false }) actionsTemplate: TemplateRef<any>;

  get iconName() {
    switch (this.type) {
      case 'info':
        return 'info-green';
      case 'warning':
        return 'info-notification-blue';
      case 'danger':
        return 'notification-icon';
      case 'error':
        return 'error-notification';
      case 'neutral':
        return null;
      default:
        return 'info-green';
    }
  }

  get iconFill() {
    switch (this.type) {
      case 'danger':
        return 'var(--ppl-orange-600)';
      case 'error':
        return 'var(--ppl-red-700)';
      case 'warning':
        return 'var(--ppl-color-600)';
      case 'info':
        return 'var(--ppl-color-900)';
      default:
        return null;
    }
  }

  @HostBinding('class')
  get className() {
    switch (this.type) {
      case 'info':
        return 'box-info';
      case 'warning':
        return 'box-warning';
      case 'danger':
        return 'box-danger';
      case 'error':
        return 'box-error';
      case 'neutral':
        return 'box-neutral';
      default:
        return 'box-info';
    }
  }
}

export type PplInfoBoxType = 'info' | 'warning' | 'danger' | 'error' | 'neutral';
